import PropTypes from 'prop-types'
import React from 'react'
import VerticalVideo from './vertical-video'

const Vertical = ({
  index,
  vertical,
  activeVertical,
  isMobile,
  handleClick
}) => {
  let classes = 'vertical-item'
  if (activeVertical === index) {
    classes = 'vertical-item is-active'
  }

  return (
    <li className={classes}>
      <VerticalVideo
        index={index}
        vertical={vertical}
        isMobile={isMobile}
        activeVertical={activeVertical}
      />
      <div className='vertical-item__details'>
        <span className='vertical-item__platform'>{vertical.platform}</span>
        <h2 className='vertical-item__title'>{vertical.title}</h2>
        <div className='vertical-item__description'>
          <p>{vertical.description}</p>
        </div>
        <div className='vertical-item__footer'>
          <span
            id={vertical.title.trim().replace(/\s+/g, '-')}
            className='vertical-item__cta'
            onClick={handleClick}
          >
            {vertical.cta.title}
          </span>
        </div>
      </div>
    </li>
  )
}

Vertical.propTypes = {
  activeVertical: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  vertical: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired
}

export default Vertical



// WEBPACK FOOTER //
// ./src/components/vertical.js